<template>
  <div>
    <table border="1" style="border-collapse: collapse;">
      <tr>
        <th>
          Name
        </th>
        <th>
          Quantity
        </th>
      </tr>
      <test-row 
      v-for="item in items"
      :key="item.inventory_item_id"
      :item="item">

      </test-row>
    </table>
  </div>
</template>

<script>
import axios from 'axios'
import TestRow from './test-row'

export default {
  data () {
    return {
      items: []
    }
  },
  components: {
    TestRow
  },
  methods: {
    reload () {
      return axios.all([
        this.$axios.get('/test/')
        ])
        .then(axios.spread((items) => {
          this.items = items.data
          console.log(this.items)
        }))
        .catch(error => this.$root.$errorSnackbar(error))
        .then(() => this.snackbarLoading = false)
    }
  },
  created () {
    this.reload()
  }
}
</script>

<style scoped lang="scss">
::v-deep table {
  & td {
    padding: 5px;
  }
}
</style>

